export const Events = {
  USER_ERROR: "Received user error",
  SERVER_ERROR: "Received server error",
  VIEWED_ESTIMATE: "Viewed estimate form",
  COMPLETED_ESTIMATE: "Submitted estimate",
  VIEWED_ESTIMATE_RESULT: "Viewed estimate result",
  CLICKED_ESTIMATE_OFFER: "Clicked estimate offer",
  VIEWED_404: "Viewed quote 404 page",
  PRESENTED_DRIVA: "Presented Driva offer",
  PRESENTED_LOAN_OPTIONS: "Presented LoanOptions offer",
  BOOKED_APPOINTMENT: "Booked Appointment",
  EXPERIMENT_LOADED: "Experiment loaded",
  CLICK_RE_BOOKING_BUTTON: "Clicked RE booking button",
  PRESENTED_DECLINE_REFERRAL_OFFER: "Presented decline referral offer",
  CLICKED_DECLINE_REFERRAL_OFFER: "Clicked decline referral offer",
} as const;

export const QUOTE_APPLICATION = "Wisr website";
export const UNEXPECTED_ERROR = "Unexpected Error";

export const LoanStatus = {
  QUOTE_STARTED: "Started estimate",
  QUOTE_SUBMITTED: "Submitted estimate",
  ESTIMATE_PRESENTED: "Presented estimate",
  APPLICATION_STARTED: "Started application",
} as const;

export const HotjarAttributes = {
  VIEWED_ESTIMATE_RESULT: "Viewed estimate result",
} as const;

export const ViewedEstimateResult = {
  OFFER: "offer",
  DECLINED: "declined",
  IDENTITY_FAILED: "identity failed",
} as const;

export const RateEstimatePages = {
  PURPOSE: "loan purpose",
  CAR_FOUND: "found car",
  CAR_YEAR: "car manufacture year",
  CAR_SELLER: "car seller",
  CAR_AGE: "car age",
  ASSET_SECURITY: "asset security",
  AMOUNT: "loan amount",
  ABOUT_YOU: "about you",
  CITIZENSHIP_STATUS: "citizenship status",
  RELATIONSHIP_STATUS: "marital status",
  LIVING_SITUATION: "living arrangement",
  INVESTMENT_OWNED: "own investment property",
  INVESTMENT_MORTGAGED: "investment mortgaged",
  CURRENT_ADDRESS: "address",
  CURRENT_MOVED_IN: "how long at address",
  PREVIOUS_ADDRESS: "previous address",
  PREVIOUS_MOVED_IN: "how long at previous address",
  CURRENT_EMPLOYMENT_STATUS: "employment status",
  CURRENT_EMPLOYMENT_LENGTH: "how long at employment",
  PREVIOUS_EMPLOYMENT_STATUS: "previous employment status",
  PREVIOUS_EMPLOYMENT_LENGTH: "how long at previous employment",
  INCOME: "income",
  NO_MATCH: "no match",
  IDENTIFICATION: "identification",
};

export const LoanConsultantConfirmedPage = {
  BRAZE_EVENT_NAME: "RM_Call_Requested",
  AMPLITUDE_PAGE_NAME: "Booking confirmation",
};

export const BRAZE_DELAY = 2000;
